import { inspectionsService } from '@/services/inspections';
import type { GetInspectionsParams } from '@/services/inspections/types';
import { STALE_TIME_THIRTY_SECONDS_MS } from '@/shared/constants/query-stale-time.constants';
import { useQuery } from '@tanstack/react-query';

interface UseInspectionsOptions extends GetInspectionsParams {
  enabled?: boolean;
}

export function useInspections(options: UseInspectionsOptions = {}) {
  const { enabled = true, ...params } = options;

  return useQuery({
    queryKey: ['inspections', params],
    queryFn: async () => {
      const response = await inspectionsService.getInspections(params);

      if (!response.success || !response.data) {
        throw new Error(response.error || 'Erro ao carregar inspeções');
      }

      return response.data;
    },
    staleTime: STALE_TIME_THIRTY_SECONDS_MS,
    enabled,
  });
}
